import {
  CONSENT_STATUS,
  type ConsentSettings,
  type ConsentStatus,
} from '../types/analytics';

export const GTM_SCRIPT_ID = 'hopsa-gtm-script';
export const TIKTOK_SCRIPT_ID = 'hopsa-tiktok-pixel-script';
export const TIKTOK_PIXEL_ID = 'D9FNM1RC77U0255M81NG';
export const DATA_LAYER_KEY = 'dataLayer';
export const GTM_EVENT_NAME = 'gtm.js';
export const ANALYTICS_CONFIG_EVENT_NAME = 'analytics_config';

export const ANALYTICS_EVENT_NAMES = {
  ACTIVATION_FIRST_PLAN_GENERATED: 'activation_first_plan_generated',
  PLUS_SUBSCRIPTION_CHECKOUT_STARTED: 'plus_subscription_checkout_started',
  TRIP_SETUP_STARTED: 'trip_setup_started',
  TRIP_SETUP_COMPLETED: 'trip_setup_completed',
  TRIP_CANDIDATES_GENERATED: 'trip_candidates_generated',
  ITINERARY_PLAN_COMPLETED: 'itinerary_plan_completed',
  PLAN_VIEWED: 'plan_viewed',
  PLAN_EDITED: 'plan_edited',
  PLAN_SAVED: 'plan_saved',
  PLAN_EXPORTED: 'plan_exported',
  PLAN_SHARED: 'plan_shared',
  SIGN_UP_STARTED: 'sign_up_started',
  SIGN_UP_COMPLETED: 'sign_up_completed',
  LOGIN: 'login',
  COMPLETE_REGISTRATION: 'complete_registration',
  PLANNER_STEP: 'planner_step',
  PURCHASE_COMPLETED: 'purchase_completed',
  CHECKOUT_CANCELED: 'checkout_canceled',
  OAUTH_SIGN_IN_STARTED: 'oauth_sign_in_started',
  UPGRADE_CTA_CLICKED: 'upgrade_cta_clicked',
  PATH_SELECTED: 'path_selected',
  PLAN_GENERATED: 'plan_generated',
  SHOWCASE_VIEWED: 'showcase_viewed',
  SHOWCASE_CTA_CLICKED: 'showcase_cta_clicked',
  ANCHOR_POI_ADDED: 'anchor_poi_added',
} as const;

export const CONSENT_STORAGE_KEY = 'consent-settings';
export const CONSENT_WAIT_FOR_UPDATE_MS = 500;

export const DEFAULT_CONSENT_STATUS: ConsentStatus = CONSENT_STATUS.DENIED;

// Stored as raw value — the OVERRIDE_VITE_* placeholder survives in the bundle
// and init-runtime.sh sed replaces it at container startup.
// Do NOT compare import.meta.env here: Vite inlines the value at build time
// and esbuild constant-folds any === comparison, eliminating the placeholder.
export const DEFAULT_CONSENT_SETTINGS: ConsentSettings = {
  adStorage: DEFAULT_CONSENT_STATUS,
  adUserData: DEFAULT_CONSENT_STATUS,
  adPersonalization: DEFAULT_CONSENT_STATUS,
  analyticsStorage: (import.meta.env.VITE_DEFAULT_ANALYTICS_CONSENT || DEFAULT_CONSENT_STATUS) as ConsentStatus,
  functionalityStorage: DEFAULT_CONSENT_STATUS,
  personalizationStorage: DEFAULT_CONSENT_STATUS,
  securityStorage: CONSENT_STATUS.GRANTED,
  waitForUpdate: CONSENT_WAIT_FOR_UPDATE_MS,
};
